import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import styles from './App.module.scss'
import { FaWhatsapp } from 'react-icons/fa'
import ScrollToTop from './utils/ScrollToTop/ScrollToTop'

function App() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <ScrollToTop />
      {/* === NAVBAR === */}
      <nav className={styles.navbar}>
        <div className={styles.navContent}>
          <div
            onClick={() => {
              window.location.href = '/'
            }}
            className={styles.logo}
          >
            <span className={styles.logoFirst}>LAGUINDA</span>
            <span className={styles.logoSecond}>WS</span>
          </div>
          <button
            onClick={() => {
              window.open('https://wa.me/224621994206', '_blank')
            }}
            className={styles.devisBtn}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              columnGap: '5px',
            }}
          >
            <FaWhatsapp size={20} /> <span>+224 621 99 42 06</span>
          </button>
        </div>
      </nav>
      <div style={{ minHeight: '70vh' }}>
        <Outlet />
      </div>
    </>
  )
}

export default App
